import { useCallback, useState, type ReactNode } from "react";
import styles from "./BackgroundDim.module.css";
import { DimContext, type Dim } from "./useBackgroundDim.js";

/** How far the universe is darkened once dimmed, 0..1. */
const DIM_OPACITY = 0.5;

/**
 * A layer over the universe that darkens it from the intro on. Lives outside the routes,
 * so the background stays dark from screen to screen.
 */
export function BackgroundDimProvider({ children }: { children: ReactNode }) {
  const [state, setState] = useState({ dimmed: false, durationMs: 0 });
  const dim = useCallback<Dim>(
    (durationMs) => setState((prev) => (prev.dimmed ? prev : { dimmed: true, durationMs })),
    [],
  );

  return (
    <DimContext.Provider value={dim}>
      <div
        className={styles.dim}
        aria-hidden="true"
        style={{
          opacity: state.dimmed ? DIM_OPACITY : 0,
          transitionDuration: `${state.durationMs}ms`,
        }}
      />
      {children}
    </DimContext.Provider>
  );
}
